/**
 * Created by Jan Bradac on 16.7.2016.
 */

(function (Lfl, $, undefined) {
    /*
     |==============================================================================================================
     | Documentation
     |==============================================================================================================
     */
    /**
     * @memberOf Lfl
     */
     Lfl.Log;


    (function (Log, $, undefined) {
        if(Lfl.Files.isLoadedAlready(Lfl.Log, '-log')) {
            return;
        }

        /*
         |===========================================================================================================
         | Object definition
         |===========================================================================================================
         */

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /**
         * Disables output into console to prevent errors (in browsers that don't support logging) and slowdowns.
         *
         * All console logging should be removed in production code, but this serves as a fallback.
         *
         * Sources: http://stackoverflow.com/a/7042634/5500468
         *
         * @memberOf Lfl.Log
         */

        Log.disableConsole = function() {
            console = {};
            // TODO - call our own methods here?
            console.log = function(){};
            console.info = function(){};
            console.warn = function(){};
            console.error = function(){};

            window.console = console;
        };

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */
    }(Lfl.Log = Lfl.Log || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
